import api from "@/plugins/axios";

// Petit cache mémoire : évite de recharger les mêmes données en naviguant.
const cache = new Map();
const TTL = 60 * 1000;

async function get(url, params = {}) {
  const key = url + JSON.stringify(params);
  const hit = cache.get(key);
  if (hit && Date.now() - hit.time < TTL) return hit.data;
  const { data } = await api.get(url, { params });
  cache.set(key, { data, time: Date.now() });
  return data;
}

export const getAccueil = () => get("/accueil");
export const getParametres = () => get("/parametres");
export const getPublications = (params = {}) => get("/publications", params);
export const getPublication = (slug) => get(`/publications/${encodeURIComponent(slug)}`);
export const getFiliale = (slug) => get(`/filiales/${encodeURIComponent(slug)}`);

export async function envoyerMessage(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

/** Transforme une erreur axios en message lisible. */
export function messageErreur(error, fallback = "Une erreur est survenue. Merci de réessayer.") {
  if (error?.response?.data?.erreur) return error.response.data.erreur;
  if (error?.code === "ECONNABORTED" || !error?.response) {
    return "Impossible de joindre le serveur. Vérifiez votre connexion internet.";
  }
  return fallback;
}
